import { EnvironmentModel } from "./model";

export const environment: EnvironmentModel = {
    production: true,
    showBetaFeatures: true,
    showAllCountries: false,
    showMicrosoft: false,
    hideReportingDashboardNewsCard: false,
    baseUrl: 'https://api.circleback.com',
    socketUrl: 'wss://api-websocket.salesintel.io',
    churnZeroAppKey: '1!Bc5n65bB6k1uqTwzjTl9hr0ajUh4QqXGpYDIdjCLwg4t95F',
    intercomAppId: 'l3zgofpl',
    icpIntel: {
      maxKeyWordsChartItemsCount: 50,
      aggregation: {
        poll: {
          timeout: 300000,// milliseconds (5 min)
          interval: 5000,// milliseconds (5 sec)
        },
        companies: {
          max: 25000
        }
      },
      inference: {
        poll: {
          timeout: 180000,
          interval: 10000,
        },
        score: {
          min: 60,
          max: 100,
          enabled: true
        },
        companies: {
          max: 1000,
          min: 10,
        }
      }
    },
    launchDarklyClientId: '6489ed1e125f5e1af905842c',
    tokenExpiry: 14,
    maxExports: 5000,
    maxXLExports: 10000,
    maxAsyncExports: 100000,
    maxMatchIdsV2Count: 10000,
    maxNewsAlertCompaniesCount: 10000,
    salesforceMaxCount: 1000,
    salesLoftMaxCount: 200,
    hubSpotMaxCount: 500,
    outReachMaxCount: 1000,
    marketoMaxCount: 1000,
    showBounceIntelCRM: true,
    dynamicTechnographics: true,
    isFreeTrialSignupEnabled: true,
    environmentIdentifier: 'prod',
    version: '4.0.0',
    isDatadogAllowed: true,
    adsIntelUrl: 'https://api-util.adsintel.salesintel.io/api/public/ads_intel/access',
    prospectConnectUrl: 'https://prospectconnect.salesintel.io/access',
    icpAutomationSavedSearchCountsLimit: 2000000,
    dataDog: {
        applicationId: '97dc3570-2ac8-4759-b2b6-1a1ded1bf2ee',
        clientToken: 'pubc8d8be69c403298088665ab67071bfc2',
        site: 'datadoghq.com',
        service: 'contactcloud-ui',
        env: 'prod',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
    },
    kinde: {
        audience: 'https://api.salesintel.io',
        client_id: '3485f6cb7ac34a63bd68719b35b932de',
        domain: 'https://sso.salesintel.io',
        redirect_uri: 'https://app.salesintel.io/account/login',
        logout_uri: 'https://app.salesintel.io/account/login?logout=true',
    },
    salesforce: {
        clientId: '3MVG9Km_cBLhsuPywpBj.myPLC9T9C5jOpFHhRc2cie7Os79_el9uNTeCQKHzQn_bzaqyGGeMqoxP1ZzjkfLC',
        redirectUrl: 'https://app.salesintel.io/sfoauth',
        authUrl: 'https://login.salesforce.com/services/oauth2/authorize',
        sandboxUrl: 'https://test.salesforce.com/services/oauth2/authorize'
    },
    hubspot: {
        clientId: 'c377be6d-ff15-49b8-bbf3-0ad97caa1d6e',
        redirectUrl: 'https://app.salesintel.io/hsoauth',
        authUrl: 'https://app.hubspot.com/oauth/authorize'
    },
    hubspotFilters: {
        clientId: '70c4cf58-b31d-41cc-a040-e2b059de9f30',
        redirectUrl: 'https://app.salesintel.io/hsFilters',
        authUrl: 'https://app.hubspot.com/oauth/authorize'
    },
    hubspotBceEnrichment: {
        clientId: '10eb763f-c3a3-4eac-bb4f-effe09203741',
        redirectUrl: 'https://app.salesintel.io/hsEnrichBCE',
        authUrl: 'https://app.hubspot.com/oauth/authorize'
    },
    hubspotEnrichment: {
        clientId: '9760cc84-2ad8-4858-8acf-9e759a7bce64',
        redirectUrl: 'https://app.salesintel.io/hsEnrich',
        authUrl: 'https://app.hubspot.com/oauth/authorize'
    },
    salesloft: {
        clientId: '6967ff2a8b57d196f9830aee0870a19c45e1034a179a3e424d9a680cf77fe57c',
        redirectUrl: 'https://app.salesintel.io/sloauth',
        authUrl: 'https://accounts.salesloft.com/oauth/authorize'
    },
    outreach: {
        clientId: '8d1d03cb8a12082c37614b196dc71873695c6473ef0e0354335d07c74f636c92',
        redirectUrl: 'https://app.salesintel.io/oroauth',
        authUrl: 'https://api.outreach.io/oauth/authorize',
        redirectOutreachAppUrl: 'https://app.salesintel.io/outreach/'
    },
    dynamics: {
        clientId: 'cb891308-938b-4dd6-9a8e-e20ebe53cc1f',
        redirectUrl: 'https://app.salesintel.io/dyauth',
        authUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
    },
    zoho: {
        clientId: '1000.Y56O13AQLG29A80TQHE2CG6RMBWY0A',
        redirectUrl: 'https://app.salesintel.io/zhoauth',
        authUrl: 'https://accounts.zoho.com/oauth/v2/auth'
    },
    google: {
        clientId: '600022112914-3nfmm5n40b224ttj3kgadtmso05ivqhi.apps.googleusercontent.com',
        redirectUrl: 'https://app.salesintel.io/results/inboxintel',
        authUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
        applicationName: 'SI-Portal'
    },
    microsoft: {
        clientId: '0b531f62-8a8a-4053-abe9-242bdc1065fd',
        redirectUrl: 'https://app.salesintel.io/results/inboxintel',
        authUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
        applicationName: 'SI-Portal'
    },
    reCaptchaSiteKey: '6LdEducUAAAAAJKcyeB8ti9i6qjPH80eP2BUNX_G',
    brandfetchKey: '1idQo9LERKDSjNIWxOw',
    brandfetchUrl: 'https://cdn.brandfetch.io/',
    hmacSecretKey: '9406e97fa9832eac6b60738e68b1ca24'
};
